export default "__VITE_ASSET__DxAdb9Ej__"